/**
 * True for stale-chunk load failures ("Failed to fetch dynamically
 * imported module: …") that happen when a new deploy invalidates assets
 * the already-running app still points at. Such failures are recovered by
 * reloading the page instead of showing the user a crash screen.
 */
export const isDynamicImportLoadError = (error: unknown): error is Error =>
  error instanceof Error && error.message.includes('dynamically imported module');
